// extracted by mini-css-extract-plugin
export default {"title_time_wrapper":"Player_title_time_wrapper__kYMFo","buttons_volume_wrapper":"Player_buttons_volume_wrapper__78zfs"};